import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-onboarding-steps',
  templateUrl: './onboarding-steps.component.html',
  styleUrls: ['./onboarding-steps.component.scss']
})
export class OnboardingStepsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
